import React from 'react';
import { ConfirmDialog as SharedConfirmDialog } from '@packages/ui';

type ConfirmDialogType = 'warning' | 'danger' | 'info' | 'success';

interface ConfirmDialogProps {
  isOpen: boolean;
  title: string;
  message: string;
  type?: ConfirmDialogType;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  isOpen, title, message, type = 'warning',
  confirmText = '确定', cancelText = '取消',
  onConfirm, onCancel,
}) => {
  return (
    <SharedConfirmDialog
      isOpen={isOpen}
      title={title}
      message={message}
      type={type}
      confirmText={confirmText}
      cancelText={cancelText}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
};

export default ConfirmDialog;
